import type { ReactNode } from 'react'
import type { ApiClientError } from '@/lib/api-client'

interface Props {
  isLoading: boolean
  error: ApiClientError | Error | null
  children: ReactNode
}

/** Tiny wrapper that renders loading + error states for query-driven pages. */
export function AsyncBoundary({ isLoading, error, children }: Props) {
  if (isLoading) {
    return <div className="text-sm text-ovation-muted">Loading…</div>
  }
  if (error) {
    return (
      <div className="rounded-md border border-red-200 bg-red-50 p-4 text-sm text-red-700 break-words">
        {error.message}
      </div>
    )
  }
  return <>{children}</>
}
